import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Card, Typography, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login } from '../../models/authAPI'; // Ensure this path is correct
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const LAST_LOGIN_EMAIL_KEY = 'lastLoginEmail';

const Login = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const error = useSelector(state => state.error);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const onFinish = async (values) => {
        try {
            setLoading(true);
            const result = await login(values.email, values.password);
            setLoading(false);
            // Debug: log what we received from login
            console.log('[Login] Full result:', result);
            console.log('[Login] User object:', result.user);
            console.log('[Login] User.IsManager:', result.user?.IsManager);
            if (result.token) {
                // Remember only the email from a successful login. Never persist
                // the password in browser storage.
                localStorage.setItem(LAST_LOGIN_EMAIL_KEY, values.email.trim());
                dispatch({ type: 'SET_USER', payload: { user: result.user, token: result.token } });
                // Redirect or handle success
                navigate('/');
            } else {
                dispatch({ type: 'LOGIN_ERROR', payload: 'Invalid credentials' });
            }
        } catch (error) {
            console.error('Login failed:', error);
            dispatch({ type: 'LOGIN_ERROR', payload: 'Login failed' });
            setLoading(false);
        }
    };

    return (
        <Card style={{ maxWidth: 400, margin: '0 auto', marginTop: '20vh' }}>
            <Title level={2} style={{ textAlign: 'center' }}>Login</Title>
            <Form
                form={form}
                name="login_form"
                initialValues={{ email: localStorage.getItem(LAST_LOGIN_EMAIL_KEY) || '' }}
                onFinish={onFinish}
                autoComplete="on"
                layout="vertical"
            >
                <Form.Item
                    name="email"
                    rules={[{ required: true, message: 'Please input your Email!' }, { type: 'email', message: 'The input is not valid E-mail!' }]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" autoComplete="email" />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your Password!' }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Log in
                    </Button>
                </Form.Item>
                {error && <Alert message={error} type="error" showIcon />}
            </Form>
        </Card>
    );
};

export default Login;
